import path from "path";
const { createSlice } = require('@reduxjs/toolkit');

export function getAdminAccessCall(AdminUser_email) {
  return async function fetchSimThunk(dispatch, getState) {
    const res = await fetch(`/bizcareui/api/celcomAdmin/getAdminAccess`, {
      body: JSON.stringify({ email: AdminUser_email }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    let { result } = await res.json();
    dispatch(
      getCelcompresets({
        AdminAccess: result[0]?.ROLE || '',
        showAdminAccess: true,
      })
    );
  };
}

function getFileName(){
  console.log("getFileName Call.....")
  // const stack = new Error().stack?.split("\n") || [];
  const stack = (new Error().stack || "").split("\n").map(s => s.trim());
  console.log("Stack----", stack);
  // const line = stack.find((i) => !i.includes(process.cwd()) && !i.includes("node_modules"));
  const line = stack.find(s => s.includes("pages/api/") && !s.includes("store/Slicer/AccessSlice") 
                  && !s.includes("node_modules"));
  console.log("Line----",line);
  if(!line)
     return "UNKNOWN";
  // const match = line.match(/\((.*):\d+:\d+\)/) || line.match(/at(.*):\d+:\d+/);
  const match = line.match(/pages\/api\/(.+?):\d+:\d+/);
  console.log("Match:::", match);
  const filePath = match?.[1];
  console.log("filePath::::", filePath);
  if(!match || !filePath)
     return "UNKNOWN";
  return path.basename(match[1]);
}

// export function generateRandomXRequestIDFn(prefix = "BZC") {
export function generateRandomXRequestIDFn(prefix = "BZC", source) {
  const finalSource = source || getFileName();
  const now = new Date();
  const pad = (n) => n.toString().padStart(2, '0');
  const day = pad(now.getDay());
  const month = pad(now.getMonth());
  //const year=pad(now.getFullYear());
  //const hours=pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());
  const milliSec=now.getMilliseconds().toString().padStart(3,'0');
  const timeStamp = `${day}${month}${minutes}${seconds}${milliSec}`;
  const randomNum = Math.floor(100 + Math.random() * 900);
  // console.log("timestam--->",`${prefix}${timeStamp}${randomNum}`);
  // return `${prefix}${timeStamp}${randomNum}`;
  const requestId = `${prefix}${timeStamp}${randomNum}`;
  console.log("timestam--->",`${prefix}${timeStamp}${randomNum}`);
  console.log("requestId--->",`${requestId}`, "fileName", `${finalSource}`);
  return requestId;
}

const initialState = {
  getAuthCompany: {},
  Authpresets: {},
  Celcompresets: { AdminAccess: '', showAdminAccess: false },
  user: { AuthSelectedUser: '', MobileNum: '' },
  Adminuser: {},
  loginUser: { name: '', email: '', fromADLogin: false },
};
const AccessSlice = createSlice({
  name: 'GetAccess',
  initialState,
  reducers: {
    getCompanyData: (state, action) => {
      state.getAuthCompany = action.payload;
    },
    getUserData: (state, action) => {
      state.loginUser = action.payload;
    },
    Authpresets: (state, action) => {
      state.Authpresets = action.payload;
    },
    getCelcompresets: (state, action) => {
      state.Celcompresets = action.payload;
    },
    getLoginUser: (state, action) => {
      state.user = action.payload;
    },
    getAdminLoginUser: (state, action) => {
      state.Adminuser = action.payload;
    },
    resetState: () => initialState,
  },
});
export const {
  getCompanyData,
  getRoleData,
  Authpresets,
  getCelcompresets,
  getLoginUser,
  getAdminLoginUser,
  getUserData,
  resetState,
} = AccessSlice.actions;
export default AccessSlice.reducer;
